import { useTranslation } from "react-i18next";
import { ChildManage } from "@/pages/child-customer/view/child-manage";
import { DingTalkChildManage } from "@/pages/child-customer/view/dingtalk-child-manage";
import { ChildManagerType } from "../constant";
import { useGlobalStore } from "@/store/GlobalStore";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { URLSearchParamsHelper } from "project-config/utils/url-search";

export function useInitTabList() {
  const location = useLocation();
  const { t } = useTranslation("center");
  const { isSubAccount, isDomestic } = useGlobalStore();
  const urlSearchParamsHelper = new URLSearchParamsHelper(location.search);
  const activeName = urlSearchParamsHelper.get("activeName");
  const [currentActiveTab, setCurrentActiveTab] = useState(
    activeName ?? ChildManagerType.childManager
  );

  const defaultChildTabsList = [
    {
      label: t("child_account_list"),
      key: ChildManagerType.childManager,
      children: <ChildManage />,
      visible: true,
    },
    {
      label: t("dingtalk_child_account_list"),
      key: ChildManagerType.dingTalkChildManager,
      children: <DingTalkChildManage />,
      visible: isDomestic && !isSubAccount,
    },
  ];

  return {
    defaultChildTabsList,
    currentActiveTab,
    setCurrentActiveTab,
  };
}
